import React from 'react';
import { connect } from 'react-redux';
import { subscribe } from '../../actions/index';
import _data from '../../data';
import {db} from './../../config/firebaseConfig';

class HeroSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hero: {},
      phoneNumber: "",
      disableBtn: false,
      btnText: "Regístrame",
      errorPhoneMessage: "",
      successSubmitted: false,

    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  changeBtnText = btnText => {
    this.setState({ btnText });
  };

  handleFormValueChange(inputName, event) {
    let stateValue = {};
    stateValue[inputName] =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState(stateValue);
  }

  phoneNumberValidations(){

    const phoneNumber = this.state.phoneNumber;
    const initialNumber = phoneNumber.charAt(0);
    const threeFirstsNumber = phoneNumber.substr(0,3);
    const nineRemainNumbers = phoneNumber.substr(3);

    if(phoneNumber === ""){
      this.setState({ errorPhoneMessage: "Error: Se debe digitar un numero telefonico" });
      return false
    };
    if(isNaN(phoneNumber)){
      this.setState({ errorPhoneMessage: "Error: Se debe digitar un numero válido" });
      return false
    }
    if (initialNumber === '0' && !(phoneNumber.length === 10)){
      this.setState({ errorPhoneMessage: "Error: El número telefónico debe tener 10 dígitos" });
      return false;
    }else if(threeFirstsNumber === '593' && !(nineRemainNumbers.length === 9)){
      this.setState({ errorPhoneMessage: "Error: El número telefónico debe tener 9 dígitos " });
      return false;
    }else{
      this.setState({ errorPhoneMessage: "" });
      return true;
    }
    
  }



  validatePhoneNumber = async () =>{
    console.log(this.state.phoneNumber);
    const phone = this.state.phoneNumber;
    await db.collection('phone-sign-ups').where('phoneNumber','==',phone).get()
    .then((snapshot) => {
      if (!snapshot.empty) {
        this.setState({ errorPhoneMessage: "Error: El número telefónico ya esta registrado" });
        return;
      }else{
        this.savephoneNumber(phone);
      }
    })
    .catch((error) => console.log(error));
  }

  savephoneNumber = async (phone) =>{
    await db.collection('phone-sign-ups').doc().set({
      phoneNumber : phone
    });
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.phoneNumberValidations()) return;

    this.changeBtnText("Suscribiéndome...");
    // disable the button
    this.setState({ disableBtn: true });

    // get action
    const subscribeAction = subscribe(this.state);

    // Dispatch the contact from data
    this.props.dispatch(subscribeAction);

    // added delay to change button text to previous
    setTimeout(
      function() {
        // enable the button
        this.setState({ disableBtn: false });

        // change to button name
        this.changeBtnText("Descárgala");

        // get action again to update state
        const subscribeAction = subscribe(this.state);

        // Dispatch the contact from data
        this.props.dispatch(subscribeAction);

        this.validatePhoneNumber();

        this.setState({successSubmitted : true});

        setTimeout( () =>{
          this.setState({ successSubmitted : false});
        },3000);

        // clear form data
        this.setState({
          phoneNumber: ""
        });
      }.bind(this),
      3000
    );
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */

    this.setState({
      hero: _data.hero
    });
  }
  render() {
    return (
      <React.Fragment>
        <section
          className="hero-section pt-100 background-img"
          style={{
            backgroundImage: `url(${this.state.hero.bgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover"
          }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between py-5">
              <div className="col-md-7 col-lg-6">
                <div className="hero-content-left text-white">
                  <h1 className="text-white">
                    <span>{this.state.hero.title}</span>
                  </h1>
                  <p className="lead">
                    {this.state.hero.description}
                  </p>
                  <div className="pb-2 download">
                    <span className="ti-mobile icon-md color-secondary"></span>
                    <h5 className="strong text-white download-text">
                      Notifícame cuando esté disponible la App
                    </h5>
                  </div>

                  <form method="post" className="subscribe-form" onSubmit={this.handleSubmit}>
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control input"
                        id="phoneNumber"
                        name="phoneNumber"
                        placeholder="0998008800"
                        value={this.state.phoneNumber}
                        onChange={e => this.handleFormValueChange("phoneNumber", e)}
                      />
                      <input
                        type="submit"
                        className="button btn solid-btn"
                        id="submit"
                        value={this.state.btnText}
                        disabled={this.state.disableBtn}
                      />
                    </div>
                  </form>
                  <p className="form__p" >{this.state.errorPhoneMessage}</p>
                  { this.state.successSubmitted ? <span class="badge badge-pill badge-success ml-2">Enviado!</span> : null }
                  <div className="video-promo-content py-4 d-flex align-items-center">
                    <a
                      href="https://www.youtube.com/watch?v=9No-FiEInLA"
                      className="popup-youtube video-play-icon-without-bip video-play-icon mr-3"
                    >
                      <span className="ti-control-play"></span>
                    </a>{" "}
                    Mira Cómo Funciona
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-5">
                <div className="hero-animation-img">
                  <img
                    src={`${this.state.hero.bgImage}`}
                    alt="app"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-img-absolute">
            <img
              src="img/hero-bg-shape-1.svg"
              alt="wave shape"
              className="img-fluid"
            />
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state
}))(HeroSection);
